import { createGlobalStyle } from "styled-components";
export const GlobalStyle = createGlobalStyle `
  * {
    font-family: "Golos Text", serif;
  }

  body,
  #root {
    height: var(--app-height);
    width: 100vw;
    margin: 0;
    overflow-x: hidden;
    font-style: normal;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: #000000;
  }

  strong {
    font-weight: 600;
  }

  a {
    color: #7E6CC1;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }

  a:hover,
  a:active {
    color: #6E5CB2;
  }

  ::-webkit-scrollbar {
    width: 0.375rem;
    height: 0.375rem;
    background-color: #F3F3F3;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 0.75rem;
    background-color: #9D87F1;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #9D87F1;
  }

  ::-webkit-scrollbar-thumb:active {
    background-color: #9D87F1;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  .horizontalBarChartTooltipFlex {
    z-index: 11;
  }

  .horizontalBarChartTooltipContainer {
    background-color: rgba(255, 255, 255, 1) !important;
    color: rgba(0, 0, 0, 1) !important;
    padding: 1.25rem !important;
  }

  @media screen and (max-width: 1280px) {
    .horizontalBarChartTooltipContainer {
      padding: 1rem !important;
    }

    .barChartTooltip {
      padding: 1rem !important;
    }
  }

  .horizontalBarChartTooltipContainer::before {
    border-color: rgba(255, 255, 255, 1) transparent transparent transparent !important;
  }

  .horizontalBarChartTooltipName {
    margin-right: 1rem !important;
  }

  .barChartMouseTooltip {
    z-index: 999 !important;
  }

  .barChartTooltip {
    background-color: rgba(255, 255, 255, 1) !important;
    color: rgba(0, 0, 0, 1) !important;
    padding: 1.25rem !important;
  }

  .barChartTooltip::before {
    border-color: rgba(255, 255, 255, 1) transparent transparent transparent !important;
  }
`;
